/* TNT B·Night — shop filters (line / season / lane / colour), tile → filter, tap-to-flip cards, toast. Mirrors b.html's JS.
   2026-08-21: LINE filter (sledders|shredders) — composable with the others, `#shop?line=shredders`, chip `data-f="lineall"` = all lines, `data-tb-clear` = clear everything. */
(function(){
  var TITLE={hats:'Hats',jerseys:'Jerseys',apparel:'Apparel',decals:'Decals',winter:'Winter',summer:'Summer',sledders:'Sledders',shredders:'Shredders'};
  var state={line:null,lane:null,season:null,colour:null};
  var toast=document.getElementById('tb-toast');var tmr;
  function say(m){if(!toast)return;toast.textContent=m;toast.classList.add('show');clearTimeout(tmr);tmr=setTimeout(function(){toast.classList.remove('show');},2600);}
  function esc(s){return String(s).replace(/[&<>"]/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];});}
  function shops(){return [].slice.call(document.querySelectorAll('[data-tb-shop]'));}
  function match(c){
    if(state.line&&c.getAttribute('data-line')!==state.line)return false;
    if(state.season&&c.getAttribute('data-season')!==state.season)return false;
    if(state.lane&&c.getAttribute('data-lane')!==state.lane)return false;
    if(state.colour&&c.getAttribute('data-colour')!==state.colour)return false;
    return true;
  }
  function render(){
    shops().forEach(function(shop){
      var grid=shop.querySelector('[data-tb-grid]'),count=shop.querySelector('[data-tb-count]');
      var cards=[].slice.call(grid.querySelectorAll('.tb-card')),n=0;
      cards.forEach(function(c){var ok=match(c);c.classList.toggle('tb-hide',!ok);if(ok)n++;});
      var empty=grid.querySelector('.tb-empty');
      if(!n){if(!empty){empty=document.createElement('div');empty.className='tb-empty';empty.innerHTML=(grid.getAttribute('data-empty')||'Nothing here yet.')+' <a href="#shop" data-tb-clear>Show everything</a>';grid.appendChild(empty);}}
      else if(empty){empty.remove();}
      var bits=[];if(state.line)bits.push(TITLE[state.line]||state.line);if(state.season)bits.push(TITLE[state.season]||state.season);if(state.lane)bits.push(TITLE[state.lane]||state.lane);if(state.colour)bits.push(state.colour);
      if(count)count.innerHTML='<b>'+n+'</b> of '+cards.length+(bits.length?' · '+esc(bits.join(' · ')):'');
    });
    document.querySelectorAll('[data-f]').forEach(function(b){
      var k=b.getAttribute('data-f'),v=b.getAttribute('data-v')||null;
      var on=k==='all'?(!state.lane&&!state.season&&!state.colour):k==='lineall'?(!state.line):(state[k]===v);
      b.classList.toggle('on',on);b.setAttribute('aria-pressed',on?'true':'false');
    });
    writeHash();
  }
  function writeHash(){
    if(!shops().length)return;
    var q=[];['line','season','lane','colour'].forEach(function(k){if(state[k])q.push(k+'='+state[k]);});
    // only touch the URL when a filter is active (an empty '#shop' made Horizon's scroll container jump to the grid on load)
    if(!q.length){if(location.hash.indexOf('#shop')===0){try{history.replaceState(null,'',location.pathname+location.search);}catch(e){}}return;}
    var h='#shop?'+q.join('&');
    if(location.hash!==h){try{history.replaceState(null,'',h);}catch(e){}}
  }
  function readHash(){
    var h=location.hash||'';if(h.indexOf('#shop')!==0)return false;
    var q=h.split('?')[1]||'';state={line:null,lane:null,season:null,colour:null};
    q.split('&').forEach(function(kv){var a=kv.split('=');if(a[0]&&a[1]&&(a[0] in state))state[a[0]]=decodeURIComponent(a[1]);});
    return true;
  }
  function apply(k,v,scroll){
    if(k==='clear'){state={line:null,lane:null,season:null,colour:null};}
    else if(k==='all'){state.lane=null;state.season=null;state.colour=null;}
    else if(k==='lineall'){state.line=null;}
    else if(k==='season'||k==='lane'){state[k]=(state[k]===v?null:v);}
    else{state[k]=(state[k]===v?null:v);}
    render();
    if(scroll){var s=document.getElementById('shop');if(s)s.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});}
  }
  document.addEventListener('click',function(e){
    var b=e.target.closest&&e.target.closest('[data-f]');
    if(b){
      if(!shops().length)return; // no grid on this page → let the link go to its collection
      e.preventDefault();apply(b.getAttribute('data-f'),b.getAttribute('data-v'),b.hasAttribute('data-scroll'));return;
    }
    var c=e.target.closest&&e.target.closest('[data-tb-clear]');
    if(c){e.preventDefault();apply('clear');}
  });
  // tap-to-flip on touch: first tap shows the second view, second tap follows the link
  document.addEventListener('touchstart',function(e){
    var card=e.target.closest&&e.target.closest('.tb-card[data-has2]');
    if(card&&!card.classList.contains('flip')){card.classList.add('flip');}
  },{passive:true});
  window.addEventListener('hashchange',function(){if(readHash())render();});
  // product page gallery + variants
  var gal=document.querySelector('[data-tb-gallery]');
  if(gal){
    gal.querySelectorAll('[data-tb-thumb]').forEach(function(t){t.addEventListener('click',function(){
      var i=t.getAttribute('data-tb-thumb');
      gal.querySelectorAll('[data-tb-main]').forEach(function(m){m.classList.toggle('on',m.getAttribute('data-tb-main')===i);});
      gal.querySelectorAll('[data-tb-thumb]').forEach(function(x){x.classList.toggle('on',x===t);});
    });});
  }
  var pf=document.querySelector('[data-tb-product]');
  if(pf){
    var data=JSON.parse(pf.querySelector('[data-tb-variants]').textContent);
    var sel={};pf.querySelectorAll('[data-tb-opt]').forEach(function(g){var on=g.querySelector('.tb-chip.on');if(on)sel[g.getAttribute('data-tb-opt')]=on.getAttribute('data-val');});
    function money(c){return '$'+(c/100).toFixed(2).replace(/\.00$/,'');}
    var inited=false;
    function update(){
      var v=data.find(function(x){return Object.keys(sel).every(function(k){return x.o[k]===sel[k];});});
      var btn=pf.querySelector('[data-tb-add]'),price=pf.querySelector('[data-tb-price]'),id=pf.querySelector('input[name=id]');
      if(v){id.value=v.id;price.textContent=money(v.price);btn.disabled=!v.available;btn.textContent=v.available?(btn.getAttribute('data-add')||'Add to cart'):(btn.getAttribute('data-soldout')||'Sold out');
        // media swap if variant has its own image index
        if(inited&&v.img!=null&&gal){var th=gal.querySelector('[data-tb-thumb="'+v.img+'"]');if(th)th.click();}
      } else {btn.disabled=true;btn.textContent=btn.getAttribute('data-unavail')||'Unavailable';}
      // grey out impossible values
      pf.querySelectorAll('[data-tb-opt]').forEach(function(g){var k=g.getAttribute('data-tb-opt');g.querySelectorAll('.tb-chip').forEach(function(ch){
        var test=Object.assign({},sel);test[k]=ch.getAttribute('data-val');
        var ok=data.some(function(x){return x.available&&Object.keys(test).every(function(kk){return x.o[kk]===test[kk];});});
        ch.classList.toggle('off',!ok);});
        var lab=g.querySelector('[data-tb-sel]');if(lab)lab.textContent=sel[k]||'';});
      try{history.replaceState(null,'',location.pathname+(v?'?variant='+v.id:''));}catch(e){}
    }
    pf.querySelectorAll('[data-tb-opt]').forEach(function(g){g.querySelectorAll('.tb-chip').forEach(function(ch){ch.addEventListener('click',function(){
      g.querySelectorAll('.tb-chip').forEach(function(x){x.classList.remove('on');});ch.classList.add('on');sel[g.getAttribute('data-tb-opt')]=ch.getAttribute('data-val');update();});});});
    var q=pf.querySelector('[data-tb-qty]');
    if(q){pf.querySelector('[data-tb-minus]').addEventListener('click',function(){q.value=Math.max(1,(parseInt(q.value)||1)-1);});pf.querySelector('[data-tb-plus]').addEventListener('click',function(){q.value=(parseInt(q.value)||1)+1;});}
    update();inited=true;
  }
  readHash();render();
})();
